import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
import { Input } from 'antd'
export const SectionWrapper = styled(Flex)`
  width: 100%;
  height: 100vh;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: '';
  }
`
export const PaddedDiv = styled(Flex)`
  padding: 20px 25px;
  gap: 25px;
`
export const DriveIDStyle = styled(Flex)`
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 21px;
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
`

export const EmptyWrapper = styled(Flex)`
  margin: 50px 0px;
  margin: ${props => props?.isSpin && '102px 0px'};
`

export const DriveIDStyleAlignCenter = styled(Flex)`
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 21px;
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
  align-items: center;
  justify-content: center;
  display: flex;
`
export const VectorRight = styled.div`
  position: absolute;
  top: -6px;
  right: 0;
`

export const VectorLeft = styled.img`
  position: absolute;
  top: 0px;
  left: 0;
`

export const ConflictPara = styled.p`
  line-height: initial;
  font-weight: ${props => props.font && '600'};
`
export const ConflictFlex = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #eff0fc;
  border-radius: 10px;
  margin-bottom: 1rem;
  cursor: pointer;
`
export const ConflictInnerFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 10px;
`
export const ConflictInnerContent = styled.p`
  line-height: initial;
  font-weight: ${props => (props.disable ? '600' : '500')};
  color: ${props => (props.disable ? '#000' : '#999FAC')};
  font-size: ${props => (props.disable ? '0.95rem' : '0.8rem')};
  margin: 0px;
`
export const SelectAllFlex = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`
export const FileError = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4rem;
  color: red;
  font-weight: 500;
`

export const StyleInput = styled(Input)`
  &.ant-input-affix-wrapper {
    border-radius: 10px 10px 0px 0px !important;
    border-bottom: 0px;
  }
  .ant-input {
    font-weight: 400;
    font-size: 16px;
    margin-left: 10px;
  }
`